import React from 'react';
import { Link } from 'react-router-dom';
import Lock from '../../images/document-lock.png';
import Thumb1 from '../../images/pseudodocs/preview-thumbnail-1.jpg';
import Thumb2 from '../../images/pseudodocs/preview-thumbnail-2.jpg';
import Thumb3 from '../../images/pseudodocs/preview-thumbnail-3.jpg';
import Thumb4 from '../../images/pseudodocs/preview-thumbnail-4.jpg';
import Thumb5 from '../../images/pseudodocs/preview-thumbnail-5.jpg';
import Thumb6 from '../../images/pseudodocs/preview-thumbnail-6.jpg';
import Thumb7 from '../../images/pseudodocs/preview-thumbnail-7.jpg';
import Thumb8 from '../../images/pseudodocs/preview-thumbnail-8.jpg';
import Thumb9 from '../../images/pseudodocs/preview-thumbnail-9.jpg';
import Thumb10 from '../../images/pseudodocs/preview-thumbnail-10.jpg';
import Thumb11 from '../../images/pseudodocs/preview-thumbnail-11.jpg';
import Thumb12 from '../../images/pseudodocs/preview-thumbnail-12.jpg';

const AnonOfferDocuments = () => {
  const possibleThumbs = [
    Thumb1,
    Thumb2,
    Thumb3,
    Thumb4,
    Thumb5,
    Thumb6,
    Thumb7,
    Thumb8,
    Thumb9,
    Thumb10,
    Thumb11,
    Thumb12,
  ];
  const possibleTitles = [
    'Our Presentation',
    'Entoro Analysis',
    'Summary of Terms',
  ];
  const documents = [];

  while (documents.length < 3) {
    const thumbIndex = Math.floor(Math.random() * possibleThumbs.length);
    const titleIndex = Math.floor(Math.random() * possibleTitles.length);
    documents.push({
      previewImageUrl: possibleThumbs.splice(thumbIndex, 1),
      title: possibleTitles.splice(titleIndex, 1),
    });
  }

  return (
    <div className='max-width-div add-margin'>
      <div className='black-44'>Documents and Media</div>
      <div className='docu-card-wrapper'>
        {documents.map(({ title, previewImageUrl }) => (
          <div key={title} className='docu-card-container'>
            <div
              className='card-docu-preview'
              style={{
                backgroundImage: `url('${previewImageUrl}')`,
                backgroundSize: 'cover',
                height: '200px',
              }}
            />
            <div className='card-docu-title'>
              <div>{title}</div>
              <div
                className='sign-up-links'
                style={{ backgroundImage: `url(${Lock})` }}
              >
                <Link
                  className='btn-download w-inline-block'
                  target='_blank'
                  to='/login'
                >
                  Sign in
                </Link>
                &nbsp;or&nbsp;
                <Link
                  className='btn-download w-inline-block'
                  target='_blank'
                  to='/register'
                >
                  join
                </Link>
                &nbsp;to view
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AnonOfferDocuments;



// WEBPACK FOOTER //
// ./src/components/OfferOverview/AnonOfferDocuments.js